module.exports = __webpack_public_path__ + "img/img_tag_black.142fb995.svg";